'use client';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer, viewportOnce } from '@/lib/motion';

/**
 * Reveal / RevealItem — scroll-triggered entrance wrappers using the canonical
 * lib/motion variants. `initial={false}` keeps SSR content visible if JS fails.
 */
export function Reveal({ children, variant, stagger, as = 'div', className = '', style }) {
  const M = motion[as] || motion.div;
  if (stagger) {
    return (
      <M
        className={className}
        style={style}
        variants={staggerContainer(typeof stagger === 'number' ? stagger : 0.08)}
        initial={false}
        whileInView="show"
        viewport={viewportOnce}
      >
        {children}
      </M>
    );
  }
  return (
    <M
      className={className}
      style={style}
      variants={variant || fadeUp}
      initial={false}
      whileInView="show"
      viewport={viewportOnce}
    >
      {children}
    </M>
  );
}

export function RevealItem({ children, variant, as = 'div', className = '', style }) {
  const M = motion[as] || motion.div;
  return (
    <M className={className} style={style} variants={variant || fadeUp}>
      {children}
    </M>
  );
}
